<script setup>
import { blackweekItemActive } from '../../helpers.js';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
    imgRatio: {
        type: String,
        default: null,
        validator: (v) => v === null || ['3_16', '16_9', '1_1', '9_16'].includes(v)
    },
    alt: { type: String, default: 'Blackweek Special' },
    imgClass: { type: String, default: 'w-full h-auto' }
});

const base = '/hkcm/images/blackweek/BlackFridayBanner';
const hidden = computed(() => !blackweekItemActive());
const map = {
    '3_16': `${base}-3_16.gif`,
    '9_16': `${base}-16_9.gif`,
    '1_1': `${base}-1_1.gif`,
    '16_9': `${base}-9_16.gif`
};

const route = useRoute();
const isHome = computed(() => route.path === '/');
</script>

<template>
    <component :is="isHome ? 'RouterLink' : 'div'" class="w-full" :class="{ hidden: hidden }" v-bind="isHome ? { to: '/produkte' } : {}">
        <img v-if="imgRatio" :src="$asset(map[imgRatio], 'public')" :alt="alt" :class="imgClass" />

        <picture v-else>
            <source :srcset="$asset(map['3_16'], 'public')" media="(min-width: 1020px)" />
            <source :srcset="$asset(map['9_16'], 'public')" media="(min-width: 900px)" />
            <source :srcset="$asset(map['1_1'], 'public')" media="(min-width: 600px)" />
            <source :srcset="$asset(map['16_9'], 'public')" media="(min-width: 400px)" />

            <img :src="$asset(map['3_16'], 'public')" :alt="alt" :class="imgClass" />
        </picture>
    </component>
</template>
